import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const MfaConfirmDialog = ({ open, mode, onClose, onConfirm }) => {
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setPassword(""); setCode(""); } }, [open]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await onConfirm(password, code.trim());
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="mfa-confirm-dialog">
        <DialogHeader>
          <DialogTitle>{mode === "disable" ? "Turn off two-factor authentication" : "Create new recovery codes"}</DialogTitle>
          <DialogDescription>
            {mode === "disable" ? "Confirm it's you. Your account will only need a password afterwards." : "Your old recovery codes will stop working."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label className="text-xs">Current password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" className="mt-1" data-testid="mfa-confirm-password" /></div>
          <div><Label className="text-xs">Authenticator or recovery code</Label><Input value={code} onChange={(e) => setCode(e.target.value)} autoComplete="one-time-code" className="mt-1 font-mono" data-testid="mfa-confirm-code" /></div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
            <Button type="submit" disabled={busy || !password || code.trim().length < 6} className={mode === "disable" ? "bg-red-600 hover:bg-red-700 text-white" : ""} data-testid="mfa-confirm-submit">
              {busy ? "Checking…" : mode === "disable" ? "Turn off" : "Create codes"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
